// extracted by css-extract-rspack-plugin
export default {"pickerWrap":"DateRangePicker_pickerWrap__23pPD","shortcuts":"DateRangePicker_shortcuts__6-QWb","darkText":"DateRangePicker_darkText__qQYwq"};